import { createComponent } from '@carvana/merch-components';

export const LowResultWrapper = createComponent('section', {
  className: 'mt-2xl flex flex-col items-center gap-2xl md:mt-7xl'
});

export const Heading = createComponent('h1', {
  className: 'text-text-strong t-heading-lg sm:t-heading-xl'
});

export const Subtitle = createComponent('p', {
  className: 'text-center text-text-default t-body-sm'
});
